module.exports = __webpack_public_path__ + "static/img/news.8a38eea6.png";